import React from 'react'
import Select from 'react-select'

// Thin wrapper around react-select that applies a shared CSS class
// so styling (including brand colours) is controlled purely via CSS.
//
// Props: all react-select props are passed straight through.
export default function StyledSelect(props) {
  return (
    <Select
      {...props}
      classNamePrefix="styled-select"
    />
  )
}
